import type { ReactNode } from 'react';
import { cx } from '../lib/cx';

export type PillTone = 'neutral' | 'accent' | 'ok' | 'warn' | 'danger';

const TONE: Record<PillTone, string> = {
  neutral: 'bg-white/80 text-[color:var(--v2-ink)] ring-1 ring-[color:var(--v2-stroke)]',
  accent:  'bg-[color:var(--v2-accent)] text-[color:var(--v2-accent-ink)]',
  ok:      'bg-emerald-50 text-emerald-700 ring-1 ring-emerald-200',
  warn:    'bg-amber-50 text-amber-700 ring-1 ring-amber-200',
  danger:  'bg-rose-50 text-rose-700 ring-1 ring-rose-200',
};

export function Pill({
  children,
  tone = 'neutral',
  className,
}: {
  children: ReactNode;
  tone?: PillTone;
  className?: string;
}) {
  return (
    <span
      className={cx(
        'inline-flex items-center gap-1 rounded-md px-2 py-0.5 text-[11px] font-semibold',
        TONE[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
